module.exports = __webpack_public_path__ + "static/img/sprite-icon.e66ba5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/sprite-icon.png
// module id = 7WLk
// module chunks = 15